<div class="modal-header">
    <div class="row w-100">
        <div class="col-md-11">
            <h5 class="modal-title">Quovo Link Account</h5>
        </div>
        <div class="col-md-1 pe-0">
            <button type="button" class="close float-end text-white pe-0" aria-label="Close"
                data-testid="modals.quovo-account.close-btn"
                (click)="cancel()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </div>
</div>

<div class="modal-body">
    <form name="quovoForm" novalidate>
       <div class="form-group mt-5 col-md-12 col-sm-12 col-xs-12">
            <h4>This feature is coming soon!</h4>
        </div>
    </form>
</div>


<div class="modal-footer">
    <button type="button" class="btn btn-link" (click)="cancel()"
        data-testid="modals.quovo-account.cancel-btn">
        CANCEL
    </button>

</div>
